import { Box, Divider, IconButton, List, ListItemButton, ListItemText, Menu, Stack, Typography } from "@mui/material"
import { useRef, useState } from "react"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { useParams } from "react-router"
import { Repeat } from "lib/@components/repeat"
import Iconify from "minimals-template/components/Iconify"
import { If } from "lib/@components/switch"
import { SequentialReviewSidebarItem } from "./sequential-review-sidebar-item"

export function SequentialReviewSidebar() {
    const { isSequentialReview, reviewQueue, projectName, exitReview } = useBoundContext()
    const { scheduleId } = useParams()
    const [menuOpen, setMenuOpen] = useState(false)
    const anchorRef = useRef(null)

    if (!isSequentialReview) return null

    return (
        <Box
            sx={{
                width: 280,
                flexShrink: 0,
                borderRight: 1,
                borderColor: "divider",
                bgcolor: "background.paper",
                overflowY: "auto",
                display: "flex",
                flexDirection: "column",
            }}
            data-cy="sequential-review-sidebar"
        >
            <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ px: 2, py: 1.5 }}>
                <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
                    Review All
                </Typography>
                <IconButton
                    aria-label="More options"
                    size="small"
                    ref={anchorRef}
                    onClick={openMenu}
                    data-cy="review-sidebar-menu-button"
                >
                    <Iconify icon="mdi:dots-vertical" />
                </IconButton>
                <Menu
                    anchorEl={anchorRef.current}
                    open={menuOpen}
                    onClose={closeMenu}
                    anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                    transformOrigin={{ vertical: "top", horizontal: "right" }}
                >
                    <ListItemButton onClick={handleExitReview} data-cy="exit-sequential-review">
                        <Iconify
                            icon="mdi:exit-to-app"
                            sx={{ width: 20, height: 20, mr: 1, color: "text.secondary" }}
                        />
                        <ListItemText primary="Exit Review" />
                    </ListItemButton>
                </Menu>
            </Stack>

            <Divider />

            <Box sx={{ px: 2, py: 1.5 }}>
                <Typography variant="overline" color="text.secondary">
                    Work Package
                </Typography>
                <Typography variant="body2">{projectName}</Typography>
            </Box>

            <Divider />

            <Box sx={{ px: 2, pt: 1.5, pb: 0.5 }}>
                <Typography variant="overline" color="text.secondary">
                    Schedules ({reviewQueue.length})
                </Typography>
            </Box>

            <If truthy={reviewQueue.length > 0}>
                <List disablePadding sx={{ flex: 1, overflowY: "auto" }}>
                    <Repeat
                        list={reviewQueue}
                        item={<SequentialReviewSidebarItem currentScheduleId={scheduleId} />}
                        pass="schedule"
                    />
                </List>
            </If>
        </Box>
    )

    function openMenu() {
        setMenuOpen(true)
    }

    function closeMenu() {
        setMenuOpen(false)
    }

    function handleExitReview() {
        setMenuOpen(false)
        exitReview()
    }
}
